import * as particles from "@pixi/particle-emitter";

export class TrailBehavior {
    static type = "trail";
    static editorConfig = null;

    order = particles.behaviors.BehaviorOrder.Late;
    _trailConfig = {};

    constructor(config) {
        this._trailConfig = {...config};
    }

    initParticles(first) {
        let next = first;
        while (next) {
            next.trail = new particles.Emitter(next.parent, this._trailConfig);
            next = next.next;
        }
    }

    updateParticle(particle, deltaSec) {
        particle.trail.updateOwnerPos(particle.position.x, particle.position.y);
        particle.trail.emitNow();
    }

    // recycleParticle(particle, natural) {
    //     particle.trail.destroy();
    //     particle.trail = null;
    // }
}

particles.Emitter.registerBehavior(TrailBehavior);
